import { useAssessmentContext } from '../../providers';

function InsomniaReferral() {
    const { nextQuestion, setAssessmentStep } = useAssessmentContext();

    return (
        <div className="flex flex-col gap-y-8 max-w-4xl text-center mx-auto">
            <p className="block text-sm xs:text-base leading-normal text-gray-light lg:text-[21px]">
                Good News! Costco has a special partnership with Sleepio to help with Insomnia. We
                recommend getting treated for Insomnia before treating OSA.{' '}
            </p>

            <a
                href="https://sleepio.bighealth.com/costco"
                target="_blank"
                rel="noreferrer"
                className="btn-primary"
                onClick={() => {
                    posthog?.capture('Referred to Sleepio');
                }}>
                GET STARTED WITH SLEEPIO
            </a>

            <button
                className="btn-primary bg-purple"
                onClick={() => {
                    setAssessmentStep('questions');
                    nextQuestion('highRiskSelections2');
                }}>
                I am already working with Sleepio for Insomnia and am ready to get tested for OSA.*
            </button>
            <p className="text-gray">
                *Note: this is a SLEEP test so if you are not sleeping enough then your results may
                be inconclusive.
            </p>
        </div>
    );
}

export default InsomniaReferral;
